// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f5afe6eb","455":"2d7fcf7f","977":"47517121"}[chunkId] + ".chunk.js";
};